import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import {MODALS_IDS} from "@Components/modal-container";
import type {EmbedEventsScheduleToWebpagePanelProps} from "@Panels/embed-events-schedule-to-webpage-panel/embed-events-schedule-to-webpage-panel.types";

export const openEmbedEventsScheduleModal = (props: EmbedEventsScheduleToWebpagePanelProps = {}): void => {
    window.PMW.redux.store.dispatch(
        openPanelInModal({
            modalId: MODALS_IDS.EMBED_EVENTS_SCHEDULE_MODAL,
            panelProps: props
        })
    );
}